// Wiederherstellungscodes einmalig anzeigen: kopieren, als Textdatei speichern, bestätigen.
import { useState } from "react";
import { useMeldung } from "../components/Meldungen";
import { T8C } from "./texte";

const T = T8C.sicherheit.codes;

export function Wiederherstellungscodes({ codes, onFertig }: { codes: string[]; onFertig: () => void }) {
  const meldung = useMeldung();
  const [bestaetigt, setBestaetigt] = useState(false);

  const kopieren = async () => {
    try {
      await navigator.clipboard.writeText(codes.join("\n"));
      meldung.ok(T.kopiert);
    } catch {
      meldung.fehler(new Error("Kopieren hat nicht geklappt. Bitte die Codes von Hand abschreiben."));
    }
  };

  const speichern = () => {
    const text = `${T.dateiKopf}\n\n${codes.join("\n")}\n`;
    const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = T.dateiname;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  return (
    <div className="nv-dialog">
      <h3 style={{ margin: 0 }}>{T.titel}</h3>
      <p className="seite__text">{T.text}</p>
      <ul className="nv-codes" aria-label={T.titel}>
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
      <div className="nv-zeile">
        <button type="button" className="knopf knopf--klein" onClick={() => void kopieren()}>
          {T.kopieren}
        </button>
        <button type="button" className="knopf knopf--klein" onClick={speichern}>
          {T.herunterladen}
        </button>
      </div>
      <label className="nv-schalter">
        <input type="checkbox" checked={bestaetigt} onChange={(e) => setBestaetigt(e.target.checked)} />
        <span>{T.bestaetigt}</span>
      </label>
      <div>
        <button type="button" className="knopf knopf--primaer" disabled={!bestaetigt} onClick={onFertig}>
          {T.fertig}
        </button>
      </div>
    </div>
  );
}
